export default __webpack_public_path__ + "static/1-9a805852a78c8b86755a2e7b261503d6.png";